import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
}));

const ListPicker = props => {
  const classes = useStyles();

  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  const handleChange = event => {
    props.setVal(event.target.value);
    event.preventDefault(); // I don't think this does anything
  };

  return (
    <div style={{
      textAlign: "left",
      width: "90%",
    }}>
      <FormControl variant="filled" className={classes.formControl} disabled={props.disabled} fullWidth>
        <InputLabel ref={inputLabel}>
          {props.header}
        </InputLabel>
        <Select
          value={props.val}
          onChange={handleChange}
          labelWidth={labelWidth}
        >
          <MenuItem value="">
            {"None"}
          </MenuItem>
          {props.options.map(option => 
            <MenuItem key={option} value={option}>{option}</MenuItem>
          )}
        </Select>
      </FormControl>
    </div>
  );
}

export default ListPicker;


// WEBPACK FOOTER //
// ./src/pages/ListPicker.js